<template>
  <div class="flex items-center">
    {{new Date(params.value).toLocaleDateString('es-ES', dateStringOptions)}}
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  data() {
    return {
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
    }
  },
  computed: {
    url () {
      return '/patients/patient/view/'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
